import api from "./api";

export type PermissionItem = {
  id: string;
  type: string;
  description: string;
};

export type RoleWithPermissions = {
  id: string;
  type: string;
  description: string;
  permissions: PermissionItem[];
};

export type UserAccessDetail = {
  userId: string;
  roles: string[];
  permissions: string[];
  isSuperAdmin: boolean;
  canAccessPanel: boolean;
  rolesDetail: RoleWithPermissions[];
};

export type SystemUser = {
  id: string;
  nome: string;
  email: string;
  cpf: string;
  avatar?: string | null;
  emailVerified: boolean;
  createAt: string;
  users_roles?: Array<{
    role_id: string;
    role: { id: string; type: string; description: string };
  }>;
};

export async function getRolesWithPermissions(): Promise<RoleWithPermissions[]> {
  const { data } = await api.get<RoleWithPermissions[]>(
    "/roles/with-permissions"
  );
  return data;
}

export async function getUserAccessDetail(
  userId: string
): Promise<UserAccessDetail> {
  const { data } = await api.get<UserAccessDetail>(`/users/${userId}/access`);
  return data;
}

export async function syncUserRoles(
  userId: string,
  roleIds: string[]
): Promise<{ message: string; access: UserAccessDetail }> {
  const { data } = await api.put<{ message: string; access: UserAccessDetail }>(
    `/users/${userId}/roles`,
    { role_ids: roleIds }
  );
  return data;
}

export type AccessControlListResponse = {
  results: SystemUser[];
  totalRecord: number;
  page: number;
  limit: number;
  totalPages: number;
  isSearch: boolean;
};

export async function getAccessControlUsers(params: {
  search?: string;
  page?: number;
  limit?: number;
}): Promise<AccessControlListResponse> {
  const { data } = await api.get<AccessControlListResponse>(
    "/users/access-control",
    { params }
  );
  return data;
}

export async function getSystemUsers(): Promise<SystemUser[]> {
  const { data } = await api.get<SystemUser[]>("/users");
  return data;
}
